export const styles = (theme) => ({
  root: {
    padding: 20,
  },
  logsContainer: {
    padding: 10,
    width: "100%",
    height: "calc(100vh - 200px)",
    overflowY: "scroll",
  },
  log: {
    fontSize: 13,
    fontFamily: "monospace",
  },
  logDay: {
    textAlign: "center",
    fontSize: 13,
    fontFamily: "monospace",
  },
  highlight: {
    backgroundColor: "#bbe3b6",
    padding: 0,
  },
});
